module.exports = __webpack_public_path__ + "img/play.dc66650b.png";